/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateApiKeyInput = {|
  id: string,
  name?: ?string,
  active?: ?boolean,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type updateApiKeyMutationVariables = {|
  input: UpdateApiKeyInput
|};
export type updateApiKeyMutationResponse = {|
  +updateApiKey: ?{|
    +apiKey: ?{|
      +id: string,
      +name: ?string,
      +key: ?string,
      +active: ?boolean,
    |}
  |}
|};
export type updateApiKeyMutation = {|
  variables: updateApiKeyMutationVariables,
  response: updateApiKeyMutationResponse,
|};
*/


/*
mutation updateApiKeyMutation(
  $input: UpdateApiKeyInput!
) {
  updateApiKey(input: $input) {
    apiKey {
      id
      name
      key
      active
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateApiKeyInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateApiKeyPayload",
    "kind": "LinkedField",
    "name": "updateApiKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ApiKey",
        "kind": "LinkedField",
        "name": "apiKey",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "key",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "active",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateApiKeyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateApiKeyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "updateApiKeyMutation",
    "operationKind": "mutation",
    "text": "mutation updateApiKeyMutation(\n  $input: UpdateApiKeyInput!\n) {\n  updateApiKey(input: $input) {\n    apiKey {\n      id\n      name\n      key\n      active\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '4ed41e3d9652afcc654cc3e661211556';

module.exports = node;
